// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","feeStructureContainer":"_3QupE9874o_OPavgSCiQyK","feeStructureRow":"_24APb7D_hWNYewwSf1JDEt","feeStructureItem":"_35i1fKAN7ZfHXr91mO1n6q"};